import { NavArrowUp } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from '../Icon.types';

export const ArrowUpIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <NavArrowUp width={size} height={size} color={color} {...rest} />;

ArrowUpIcon.displayName = 'ArrowUpIcon';
